define.alias("shared/components/shared/ui/report/settings-wrapper", "preview-grid/components/shared/ui/report/settings-wrapper");